export const statusColors = {
  "brilliant-rose": { 100: "#FEE5F3", 400: "#FB61AF", 500: "#FA3A9B", 800: "#A80C4C" },
  "blue-chronoflex": { 100: "#D4ECFF", 400: "#66B4FF", 500: "#41A1FF", 800: "#1746AD" },
  "international-orange": { 100: "#FFE8D4", 400: "#FF7943", 500: "#FF5714", 800: "#9E200E" },
  "pastel-green": { 100: "#DEFAE2", 400: "#57C869", 500: "#2DBA43", 800: "#1B6026" },
  "purple-heart": { 100: "#EDE4FF", 400: "#A85FFF", 500: "#9237FF", 800: "#6A00DA" },
  "navy-blue": { 100: "#E5E6FF", 400: "#6D65FF", 500: "#493FFF", 800: "#1A05D2" },
  eden: { 100: "#C7F8EE", 400: "#3DBFA8", 500: "#1AB2A1", 800: "#155551" },
  yellow: { 100: "#FEF9C3", 400: "#FBBF24", 500: "#ECD106", 800: "#854D0E" },
  red: { 100: "#FFDEDE", 400: "#FF5656", 500: "#FF2C2C", 800: "#AA0A0A" },
  "chrono-gray": { 100: "#D8DBDF", 400: "#898E99", 500: "#6B7280", 800: "#40444C" },
};
